export const getScreenImage = (_component) => {
  const component = getElement(_component);
  // const windowWidth = useRef(window.innerWidth);
  const windowWidth = window.innerWidth;

  if (component?.video) {
    return {
      isVideo: true,
      src: component?.video
    };
  }

  if (!component?.phone_image ) {
    return component?.desktop_image ?? component?.img_desktop;
  }

  const sizeWindowPhone = 600;
  const imageScreen =
    windowWidth > sizeWindowPhone
      ? component?.desktop_image ?? component?.img_desktop
      : component?.phone_image ?? component?.img_phone;
  return imageScreen;
};

function getElement(value) {
  if (Array.isArray(value)) {
    return value[0];
  }
  return value;
}
